import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	duplicateFieldsHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	duplicateFieldsContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	duplicateFieldsInfoIconMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	duplicateFieldsHeader: {
		id: 'native-issue-table.duplicate-fields-header',
		defaultMessage: 'Duplicate fields',
		description: 'Popup header for duplicate fields',
	},
	duplicateFieldsContent: {
		id: 'native-issue-table.duplicate-fields-content',
		defaultMessage: '<link>Configure fields</link> to remove duplicates',
		description:
			'Description on duplciate fields popup that describes how to configure columns to remove duplicates',
	},
	duplicateFieldsInfoIconMessage: {
		id: 'native-issue-table.duplicate-fields-info-icon-message',
		defaultMessage: 'Duplicate fields info {issueKey} {fieldName}',
		description: 'Screen reader message for info icon on duplicate fields button',
	},
});
export default messages;
